var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slotsLen)?_c('div',{staticClass:"assets-grid",style:(_vm.gridRows)},[_vm._t("default")],2):_c('el-empty',{attrs:{"description":"暂无数据"}})
}
var staticRenderFns = []

export { render, staticRenderFns }